import styled from 'styled-components';

import { ContainerProps } from './interface';

export const Container = styled.button<ContainerProps>`
  display: flex;
  flex-direction: row;
  margin-right: 1rem;
  background: none;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
  
  span {
    font-size: 22px;
    color: ${({ theme }) => theme.colors.TEXT1};
    margin-left: 0.5rem;
  }

  @media (max-width: 1024px) {

    span {
      font-size: 0.7rem;
    }
  }
`;
